import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeleteCharacteristicGroupsRequest as SchemaDeleteCharacteristicGroupsRequest } from '../schemas/DeleteCharacteristicGroupsRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const DeleteCharacteristicGroupsContentType = 'application/json' as const;
export type DeleteCharacteristicGroupsRequest = SchemaDeleteCharacteristicGroupsRequest;
export type DeleteCharacteristicGroupsResponses = LinkCommonErrorResponses & {
    /**
     * @description Characteristic groups deleted successfully
     */
    '200': {};
};
export type DeleteCharacteristicGroupsResponseSuccess = undefined;
export type DeleteCharacteristicGroupsSearchParams = undefined;
export type DeleteCharacteristicGroupsPathParameters = undefined;
export const DeleteCharacteristicGroupsUrl = '/characteristics/groups' as const;
export const DeleteCharacteristicGroupsMethod = 'DELETE' as const;
export const getDeleteCharacteristicGroupsUrl = (_params?: DeleteCharacteristicGroupsPathParameters) =>
    DeleteCharacteristicGroupsUrl;
